var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[(_vm.isDir)?_c('DirectoryIcon',{staticClass:"icon"}):_c('FileIcon',{staticClass:"icon-file"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }